import React, { Component } from 'react';

class Person extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <p>Person!</p>
    );
  }
}

export default Person;



// WEBPACK FOOTER //
// ./src/Person.jsx